import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import noop from 'lib/function/noop'
import FlashDesktopOfferHeaderGallery from './FlashDesktopOfferHeaderGallery'
import FlashDesktopOfferHeaderReviews from './FlashDesktopOfferHeaderReviews'
import FlashDesktopOfferHeaderLocation from './FlashDesktopOfferHeaderLocation'

const SIDE_COLUMN_MAX_WIDTH = 370

const Rows = styled(LayoutContainer)`
  padding-block: ${rem(20)};
`

const HeroRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${rem(40)};
`

const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

const HeroSideColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  max-width: ${rem(SIDE_COLUMN_MAX_WIDTH)};
`

const HeroSideStack = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${rem(16)};
  min-height: 0;

  > :first-child {
    flex-shrink: 0;
  }

  > :last-child {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }
`

interface Props {
  offer: App.HotelOffer
  charterBundleRoute?: App.CharterBundleRoute
  autoPlayVideo?: boolean
  onTopHeroImageLoad?: () => void
}

function FlashDesktopOfferHeader(props: Props) {
  const { offer, charterBundleRoute, autoPlayVideo = false, onTopHeroImageLoad = noop } = props

  return (
    <Rows variant="large" data-testid="flash-desktop-offer-header">
      <HeroRow>
        <MainColumn>
          <FlashDesktopOfferHeaderGallery
            offer={offer}
            charterBundleRoute={charterBundleRoute}
            autoPlayVideo={autoPlayVideo}
            onTopHeroImageLoad={onTopHeroImageLoad}
          />
        </MainColumn>
        <HeroSideColumn>
          <HeroSideStack>
            <FlashDesktopOfferHeaderReviews offer={offer} />
            <FlashDesktopOfferHeaderLocation offer={offer} />
          </HeroSideStack>
        </HeroSideColumn>
      </HeroRow>
    </Rows>
  )
}

export default FlashDesktopOfferHeader
